const CFG = {
  perPageDefault: 10,
}

export default CFG
